import { Card, Form, FormInstance } from '@pankod/refine-antd'
import React from 'react'
import sanitize from 'sanitize-html'

import { Button } from '@wartek-id/button'
import { Text } from '@wartek-id/text'

type PreviewDetailLandingPageProps = {
  form?: FormInstance
  title?: string
  description?: string
  detail?: string
  blueprintData?: {
    imageUrl: string
    title: string
    description: string
  }
}

const PreviewDetailLandingPage = (props: PreviewDetailLandingPageProps) => {
  const title = Form.useWatch('title', props?.form)
  const description = Form.useWatch('description', props?.form)
  const url = Form.useWatch('url', props?.form)
  const detail = Form.useWatch('detail', props?.form)

  return (
    <Card
      title="Preview Detail Landing Page"
      className="w-[360px] h-[808px] overflow-auto"
      size="small"
      bodyStyle={{
        padding: 0,
        background: '#efefef',
        height: 'calc(100% - 38px)',
        overflow: 'auto',
      }}
    >
      {props?.blueprintData?.imageUrl && (
        <div
          className="bg-gray-30 w-full aspect-[360_/_155]"
          style={{
            backgroundImage: `url(${props.blueprintData.imageUrl})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
        />
      )}
      <div className="p-4 bg-white">
        <Text variant="heading-md" color="default" className="mb-2">
          {title || props?.blueprintData?.title}
        </Text>
        <Text variant="body" color="subdued">
          {description || props?.blueprintData?.description}
        </Text>
        {url && (
          <Button
            as="a"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-5"
            color="white"
          >
            Baca info lebih lanjut
          </Button>
        )}
      </div>
      {detail && (
        <div
          className="prose prose-sm max-w-full p-4"
          dangerouslySetInnerHTML={{ __html: sanitize(detail) }}
        />
      )}
    </Card>
  )
}

export default PreviewDetailLandingPage
